import React from 'react'
import './index.less'

export default function ChartBlock({
  title = '',
  children,
}) {
  return (
    <div className="chart-block">
      <div className="chart-block-title">
        {title}
      </div>
      <div className="chart-block-content">
        <div className="chart-line">
          <div className="center-top-line" />
          <div className="left-circle">
            <div className="left-circle-center" />
          </div>
          <div className="center-line" />
          <div className="right-circle" />
        </div>
        {children}
      </div>
    </div>
  )
}
